(function (window, document) {
  'use strict';

  var DEFAULT_SETTINGS = {
    enabled: true,
    heading: 'Unlock Free Shipping',
    collectionHandle: '',
    collectionPath: 'collections',
    requiredTags: '',
    viewAllLimit: 15,
    initialLimit: 6,
    desktopInitialLimit: 5,
    minimumRemainingAmount: 5,
    sectionId: 'free-shipping-recommendations',
    shippingDataInputSelector: '#shippingdata_json',
    selectors: {
      upsellContainer: '.free-shipping-upsell',
      recommendationBox: '.free-shipping-recommendation-box',
      heading: '.free-shipping-header',
      cartTotal: '#main-cart-footer .cart__blocks .js-contents > div > p, #CartDrawer .totals__total-value, #cart-notification .totals__total-value, .mc-items-container .totals__total-value',
      cartTotalAttribute: '',
      tagsContainer: '#cart-tags-data',
      tagsAttribute: 'data-cart-tags',
      recommendationsTarget: '.free-shipping-product-recommendations-cart',
      headerActions: '.free-shipping-header-actions',
      collectionProducts: '.product-grid-container .grid__item, .product-grid .grid__item, .row--product-list .card--default, [data-product-card-root]',
      collectionTitle: '.card__heading a, .card__heading.h5 a, .card__title h4, .card__title',
      collectionProductLink: '.card__heading a, .full-unstyled-link, .card__title, .card__img--container',
      collectionImage: '.card__media img, .card__img img, img',
      collectionPrice: '[data-card-price-wrapper] .price__sale .price-item--sale, [data-card-price-wrapper] .price__regular .price-item--regular, .price .price-item--sale, .price .price-item--regular, .jsPrice',
      collectionVariantIdInput: 'div[data-variant-id], input[name="id"].product-variant-id, input[name="id"], select[name="id"]',
      collectionProductUrlAttribute: '[data-product-url], .card__heading a',
      collectionProductIdAttribute: 'data-product-card-swatch-id', 
      collectionVariantIdAttribute: 'data-variant-id' 
    },
    strings: {
      addToCart: 'ADD',
      soldOut: 'Sold out',
      viewAll: 'View All',
      noMatchingTags: 'No matching cart tags found for free shipping recommendations',
      noProducts: '[Recommendations] Nothing to render',
      invalidCartTotal: 'Invalid cart total',
      alreadyQualified: 'Customer already qualifies for all free shipping thresholds',
      shippingDataError: 'Shipping threshold JSON is invalid',
      cartTagsError: 'Failed to parse cart tags data',
      collectionFetchError: 'Collection Fetch Failed'
    },
    ui: {
      cardsPerRowDesktop: 5,
      cardsPerRowMobile: 3,
      cardMaxWidth: 320,
      cardPadding: 8,
      gap: 16,
      imagePadding: 4,
      addToCartButtonColor: '#ffffff',
      showDiscountedPrice: true,
      showOriginalPrice: true,
      showAddToCart: true,
      headingSize: 20
    }
  };

  function normalizeTag(tag) {
    return String(tag || '').trim().toLowerCase();
  }

  function normalizeTags(value) {
    if (Array.isArray(value)) {
      return value.map(normalizeTag).filter(Boolean);
    }

    return String(value || '').split(',').map(normalizeTag).filter(Boolean);
  }

  function toPositiveNumber(value, fallback) {
    var number = Number(value);
    return isNaN(number) || number <= 0 ? fallback : number;
  }

  function getSettings(customSettings) {
    var incoming = customSettings || window.freeShippingSettings || {};
    console.log('[FreeShipping] getSettings - start', incoming);
    var selectors = Object.assign({}, DEFAULT_SETTINGS.selectors, incoming.selectors || {});
    var strings = Object.assign({}, DEFAULT_SETTINGS.strings, incoming.strings || {});
    var ui = Object.assign({}, DEFAULT_SETTINGS.ui, incoming.ui || {});

    var resolved = Object.assign({}, DEFAULT_SETTINGS, incoming, {
      enabled: incoming.enabled !== false,
      initialLimit: toPositiveNumber(incoming.initialLimit, DEFAULT_SETTINGS.initialLimit),
      desktopInitialLimit: toPositiveNumber(incoming.desktopInitialLimit, DEFAULT_SETTINGS.desktopInitialLimit),
      viewAllLimit: toPositiveNumber(incoming.viewAllLimit, DEFAULT_SETTINGS.viewAllLimit),
      minimumRemainingAmount: toPositiveNumber(incoming.minimumRemainingAmount, DEFAULT_SETTINGS.minimumRemainingAmount),
      requiredTags: normalizeTags(incoming.requiredTags || DEFAULT_SETTINGS.requiredTags),
      selectors: selectors,
      strings: strings,
      ui: ui
    });

    console.log('[FreeShipping] getSettings - resolved', { enabled: resolved.enabled, initialLimit: resolved.initialLimit, viewAllLimit: resolved.viewAllLimit });
    return resolved;
  }

  function getShippingData(settings) {
    var input = document.querySelector(settings.shippingDataInputSelector || '#shippingdata_json');
    console.log('[FreeShipping] getShippingData - input found:', Boolean(input));
    var rawValue = input ? input.value.trim() : '';

    if (!rawValue) return null;

    try {
      var parsedValue = JSON.parse(rawValue);
      var finalParsed = typeof parsedValue === 'string' && parsedValue.trim() ? JSON.parse(parsedValue) : parsedValue;
      console.log('[FreeShipping] getShippingData - parsed', typeof finalParsed === 'object' && Object.keys(finalParsed).length ? 'object' : typeof finalParsed);
      return finalParsed;
    } catch (error) {
      console.error(settings.strings.shippingDataError, error);
      return null;
    }
  }

  function getShippingThresholds(settings) {
    var shippingData = getShippingData(settings);
    console.log('[FreeShipping] getShippingThresholds - start', { hasShippingData: !!shippingData });
    if (!shippingData) return [];

    var userCountryCode = typeof getCountryCode === 'function'
      ? getCountryCode()
      : typeof Shopify !== 'undefined'
        ? Shopify.country
        : '';

    if (!shippingData[userCountryCode]) return [];

    var thresholds = [];
    var shippingMethods = shippingData[userCountryCode]['shipping rates'] || {};

    Object.keys(shippingMethods).forEach(function (methodName) {
      var rates = (shippingMethods[methodName] || {}).rates || {};
      Object.keys(rates).forEach(function (rateKey) {
        var rateData = rates[rateKey] || {};
        var shippingPrice = Number(rateData['shipping price']);
        var minCartPrice = Number(rateData['min cart price']);

        if (shippingPrice === 0 && !isNaN(minCartPrice)) {
          thresholds.push(minCartPrice);
        }
      });
    });

    var result = thresholds.filter(function (value, index, self) {
      return self.indexOf(value) === index;
    }).sort(function (a, b) {
      return a - b;
    });
    console.log('[FreeShipping] getShippingThresholds - computed thresholds:', result);
    return result;
  }

  function getCartTotal(settings) {
    var cartTotalElement = document.querySelector(settings.selectors.cartTotal);
    console.log("idhe cart total selector", settings.selectors.cartTotal)
    console.log("idhe element", cartTotalElement)
    console.log('[FreeShipping] getCartTotal - element found:', Boolean(cartTotalElement));

    var rawValue = '';
    if (cartTotalElement) {
      rawValue = (settings.selectors.cartTotalAttribute && cartTotalElement.getAttribute(settings.selectors.cartTotalAttribute)) || cartTotalElement.textContent || '';
    }

    if (!rawValue && window.cart_total) {
      rawValue = String(window.cart_total);
    }

    if (!rawValue) {
      var cartDrawerTotal = document.querySelector('#CartDrawer .totals__total-value, #cart-notification .totals__total-value');
      if (cartDrawerTotal) {
        rawValue = cartDrawerTotal.textContent || '';
      }
    }

    rawValue = String(rawValue || '').trim();
    if (!rawValue) {
      console.log('[FreeShipping] getCartTotal - no value found, returning 0');
      return 0;
    }

    var numeric = rawValue.replace(/[^0-9.\-]+/g, '');
    var parsed = parseFloat(numeric) || 0;
    console.log('[FreeShipping] getCartTotal - raw:', rawValue, 'numeric:', parsed);
    return parsed;
  }

  function getNearestThreshold(cartTotal, settings) {
    var thresholds = getShippingThresholds(settings);
    var nearest = thresholds.find(function (threshold) { return threshold > cartTotal; });
    console.log('[FreeShipping] getNearestThreshold - cartTotal:', cartTotal, 'thresholds:', thresholds, 'nearest:', nearest);
    return nearest;
  }

  function getPriceFilter(remainingAmount, settings) {
    remainingAmount = Math.max(settings.minimumRemainingAmount, remainingAmount);
    return 'filter.v.price.lte=' + encodeURIComponent(remainingAmount);
  }

  function getMatchedCategoryFilters(settings) {
    var cartTags = new Set();
    var tagsContainer = document.querySelector(settings.selectors.tagsContainer);
    var rawTags = tagsContainer ? tagsContainer.getAttribute(settings.selectors.tagsAttribute) : '';

    if (!rawTags && Array.isArray(window.cartTags)) {
      rawTags = JSON.stringify(window.cartTags);
    }

    if (rawTags) {
      try {
        JSON.parse(rawTags).forEach(function (productTags) {
          if (!Array.isArray(productTags)) productTags = [productTags];
          productTags.forEach(function (tag) {
            tag = normalizeTag(tag);
            if (tag) cartTags.add(tag);
          });
        });
      } catch (error) {
        console.error(settings.strings.cartTagsError, error);
        return '';
      }
    } else if (Array.isArray(window.cartProductTags)) {
      window.cartProductTags.forEach(function (tag) {
        tag = normalizeTag(tag);
        if (tag) cartTags.add(tag);
      });
    }

    var cartTagsList = Array.from(cartTags);
    var matched = settings.requiredTags.filter(function (requiredTag) {
      return cartTagsList.includes(requiredTag);
    });
    console.log('[FreeShipping] getMatchedCategoryFilters - cartTags:', cartTagsList, 'required:', settings.requiredTags, 'matched:', matched);
    return matched.map(function (tag) { return 'f.Category=' + encodeURIComponent(tag); }).join('&');
  }

  function getCollectionUrl(categoryFilters, remainingAmount, settings) {
    var collectionHandle = settings.collectionHandle || '';
    if (!collectionHandle) return '';

    var collectionUrl = /^https?:\/\//i.test(collectionHandle)
      ? collectionHandle
      : (settings.collectionPath || 'collections').replace(/\/$/, '') + '/' + collectionHandle;

    var queryString = [categoryFilters, getPriceFilter(remainingAmount, settings)].filter(Boolean).join('&');
    console.log('[FreeShipping] getCollectionUrl - collectionUrl:', collectionUrl, 'queryString:', queryString);
    return queryString ? collectionUrl + '?' + queryString : collectionUrl;
  }

  function getElementAttribute(element, attributeName) {
    return element && attributeName ? element.getAttribute(attributeName) || '' : '';
  }

  function getVariantId(card, settings) {
    var variantElement = card.querySelector(settings.selectors.collectionVariantIdInput);
    var variantId = variantElement ? variantElement.value || getElementAttribute(variantElement, 'value') : '';
    return variantId || getElementAttribute(card, settings.selectors.collectionVariantIdAttribute);
  }

  function getProductId(card, addToCartButton, productUrl, settings) {
    var productId = getElementAttribute(addToCartButton, settings.selectors.collectionProductIdAttribute);
    var idElement = card.querySelector('[id*="CardLink-"], [id*="title-"]');
    var idSource = productId || getElementAttribute(addToCartButton, 'id') || getElementAttribute(idElement, 'id') || productUrl;
    var idMatch = String(idSource || '').match(/(\d+)(?!.*\d)/);
    return productId || (idMatch ? idMatch[1] : '');
  }

function parseProducts(html, settings) {
  console.log('[FreeShipping] parseProducts - starting');

  var doc = new window.DOMParser().parseFromString(html, 'text/html');
  var products = [];

  var cardNodes = Array.prototype.slice.call(
    doc.querySelectorAll(settings.selectors.collectionProducts)
  );

  console.log(
    '[FreeShipping] parseProducts - raw cards found:',
    cardNodes.length
  );

  console.log(
    '[FreeShipping] parseProducts - selector:',
    settings.selectors.collectionProducts
  );

  cardNodes.forEach(function (card) {

    console.log('[FreeShipping] ===== PRODUCT CARD DEBUG =====');
    console.log('[FreeShipping] Product card:', card);

    // Product title
    var titleSelector = settings.selectors.collectionTitle;
    var titleElement = card.querySelector(titleSelector);
    var title = titleElement ? titleElement.textContent.trim() : '';

    console.log('[FreeShipping] Product title selector:', titleSelector);
    console.log('[FreeShipping] Product title element:', titleElement);
    console.log('[FreeShipping] Product title:', title);

    // Product link
    var productLinkSelector = settings.selectors.collectionProductLink;
    var linkElement = card.querySelector(productLinkSelector);

    console.log('[FreeShipping] Product link selector:', productLinkSelector);
    console.log('[FreeShipping] Product link element:', linkElement);

    var productUrl = linkElement
      ? linkElement.getAttribute('href') || ''
      : '';

    console.log(
      '[FreeShipping] href attribute:',
      linkElement ? linkElement.getAttribute('href') : null
    );

    console.log('[FreeShipping] Product URL from link:', productUrl);

    // Price
    var priceSelector = settings.selectors.collectionPrice;
    var priceElement = card.querySelector(priceSelector);
    var priceText = priceElement
      ? priceElement.textContent.trim()
      : '';

    console.log('[FreeShipping] Price selector:', priceSelector);
    console.log('[FreeShipping] Price element:', priceElement);
    console.log('[FreeShipping] Price:', priceText);

    // Add to cart button
    var addToCartSelector = '.quick-add__submit, .button--addToCart';
    var addToCartButton = card.querySelector(addToCartSelector);

    console.log('[FreeShipping] Add to cart selector:', addToCartSelector);
    console.log('[FreeShipping] Add to cart element:', addToCartButton);

    // Fallback URL attribute
    var urlAttribute = settings.selectors.collectionProductUrlAttribute;

    console.log(
      '[FreeShipping] Product URL attribute configured:',
      urlAttribute
    );

    if (addToCartButton) {
      console.log(
        '[FreeShipping] URL attribute value on add-to-cart button:',
        addToCartButton.getAttribute(urlAttribute)
      );
    }

    // If URL wasn't found from the product link
    if (!productUrl && addToCartButton) {
      var buttonUrl = addToCartButton.getAttribute(urlAttribute) || '';

      console.log(
        '[FreeShipping] URL from add-to-cart button:',
        buttonUrl
      );

      var fallbackSelector = urlAttribute;
      var fallbackElement = card.querySelector(fallbackSelector);

      console.log(
        '[FreeShipping] Fallback selector:',
        fallbackSelector
      );

      console.log(
        '[FreeShipping] Fallback element:',
        fallbackElement
      );

      var fallbackUrl = fallbackElement
        ? fallbackElement.getAttribute('[data-product-url]') ||
          fallbackElement.getAttribute('href') ||
          ''
        : '';

      console.log(
        '[FreeShipping] URL from fallback element:',
        fallbackUrl
      );

      productUrl = buttonUrl || fallbackUrl;
    }

    console.log('[FreeShipping] ===== FINAL PRODUCT URL =====');
    console.log('[FreeShipping] Final product URL:', productUrl);

    // Product ID
    var productId = getProductId(
      card,
      addToCartButton,
      productUrl,
      settings
    );

    console.log('[FreeShipping] Product ID:', productId);

    // Variant ID
    var variantId = getVariantId(card, settings);

    console.log('[FreeShipping] Variant ID:', variantId);

    // Product image
    var imageSelector = settings.selectors.collectionImage;
    var imageElement = card.querySelector(imageSelector);

    var imageUrl = imageElement
      ? imageElement.getAttribute('src') ||
        imageElement.getAttribute('data-src') ||
        ''
      : '';

    console.log('[FreeShipping] Image selector:', imageSelector);
    console.log('[FreeShipping] Image element:', imageElement);
    console.log('[FreeShipping] Original image URL:', imageUrl);

    if (imageUrl) {
      imageUrl = imageUrl.replace(/(width=)\d+/gi, '$1240');

      if (imageUrl.indexOf('width=') === -1) {
        imageUrl +=
          (imageUrl.indexOf('?') > -1 ? '&' : '?') + 'width=240';
      }
    }

    console.log('[FreeShipping] Processed image URL:', imageUrl);

    // Validation
    var isValidProduct = !!(title && productUrl && variantId);

    console.log('[FreeShipping] Product validation:', {
      hasTitle: !!title,
      hasProductUrl: !!productUrl,
      hasVariantId: !!variantId,
      isValid: isValidProduct
    });

    if (isValidProduct) {
      var product = {
        id: productId,
        variantId: variantId,
        title: title,
        url: productUrl,
        priceText: priceText,
        imageUrl: imageUrl
      };

      products.push(product);

      console.log('[FreeShipping] Product added:', product);
    } else {
      console.warn('[FreeShipping] Product skipped:', {
        title: title,
        productUrl: productUrl,
        variantId: variantId,
        productId: productId
      });
    }
  });

  console.log(
    '[FreeShipping] parseProducts - parsed products count:',
    products.length
  );

  console.log(
    '[FreeShipping] parseProducts - final products:',
    products
  );

  return products;
}

  function fetchProductsForThreshold(categoryFilters, threshold, settings, cartTotal) {
    var remainingAmount = threshold - (typeof cartTotal === 'number' ? cartTotal : getCartTotal(settings));
    console.log('[FreeShipping] fetchProductsForThreshold start', { categoryFilters: categoryFilters, threshold: threshold, remainingAmount: remainingAmount });
    var url = getCollectionUrl(categoryFilters, remainingAmount, settings);

    if (!url) return Promise.reject('Missing collection URL');

    var requestUrl = /^https?:\/\//i.test(url)
      ? url
      : (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + url;

    console.log('[FreeShipping] fetchProductsForThreshold requestUrl:', requestUrl);

    return window.fetch(requestUrl, {
      method: 'GET',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      cache: 'no-store'
    }).then(function (response) {
      console.log('[FreeShipping] fetchProductsForThreshold response status:', response.status);
      if (!response.ok) throw new Error('Request failed with status ' + response.status);
      return response.text();
    }).then(function (html) {
      console.log('[FreeShipping] fetchProductsForThreshold response length:', html.length);
      var products = parseProducts(html, settings);
      console.log('[FreeShipping] fetchProductsForThreshold - products parsed:', products.length);
      return products;
    });
  }

  function setButtonState(button, isLoading) {
    console.log("loading state", isLoading)
    if (!button) return;

    button.disabled = isLoading;
    button.classList.toggle('loading', isLoading);
    button.setAttribute('aria-disabled', isLoading ? 'true' : 'false');

    var spinner = button.querySelector('.loading__spinner');
    if (spinner) spinner.classList.toggle('hidden', !isLoading);

    var buttonText = button.querySelector('[data-button-text]');
    if(isLoading){
      buttonText.innerHTML = 'ADDING...'
    }
    else{
      buttonText.innerHTML = 'ADD'
    }
    if (buttonText) buttonText.classList.remove('hidden');
  }

  function bindRecommendationAddToCartForms() {
    document.querySelectorAll('.free-shipping-recommendation-form').forEach(function (form) {
      if (form.__freeShippingAddToCartBound) return;
      form.__freeShippingAddToCartBound = true;
      console.log('[FreeShipping] bindRecommendationAddToCartForms - binding form');

      form.addEventListener('submit', function (event) {
        console.log('[FreeShipping] add-to-cart submit triggered');
        event.preventDefault();
        event.stopImmediatePropagation();

        var button = event.submitter || form.querySelector('[type="submit"]');
        var formData = new FormData(form);
        var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        if (cart) {
          var sectionsToRequest =  [
              'main-cart-items-short',
              'detailed-cart-footer',
              'cart-drawer',
              'cart-icon-bubble'
            ];
          console.log('[FreeShipping] add-to-cart requesting sections:', sectionsToRequest);
          formData.append('sections', sectionsToRequest.join(','));
          formData.append('sections_url', window.location.pathname);
        }

        setButtonState(button, true);

        var config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = formData;

        console.log('[FreeShipping] add-to-cart request payload:', Object.fromEntries(formData.entries()));

        window.fetch(routes.cart_add_url, config)
          .then(function (response) {
            console.log('[FreeShipping] add-to-cart response status:', response.status);
            if (!response.ok) throw new Error('Add to cart failed');
            return response.json();
          })
          .then(function (cartData) {
            console.log('[FreeShipping] add-to-cart response data:', cartData);

            var localSettings = window.freeShippingSettings ? getSettings(window.freeShippingSettings) : getSettings();

            if (cart && cartData) {
              // If the cart element exposes renderContents, prefer native render
              if (typeof cart.renderContents === 'function') {
                cart.renderContents(cartData);
              }
            }

            // Update a JS-accessible cart total when available (cart JSON uses cents)
            try {
              if (cartData && typeof cartData.total_price !== 'undefined') {
                var newTotal = Number(cartData.total_price) / 100;
                window.cart_total = newTotal;
              }
            } catch (e) {
              /* ignore */
            }

            // Publish the theme-wide cart update so native components fetch and re-render
            try {
              var publishResult = null;
              if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publishResult = publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'free-shipping-recommendations',
                  productVariantId: formData.get('id'),
                  cartData: cartData
                });
              } else if (window.PUB_SUB_EVENTS && window.publish) {
                // fallback to older global name
                publishResult = window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
                  source: 'free-shipping-recommendations',
                  productVariantId: formData.get('id'),
                  cartData: cartData
                });
              }

              var runRefresh = function () {
                refreshCartSections(localSettings).then(function () {
                  scheduleRecommendationsRefresh(localSettings, { preserveExisting: true });
                }).catch(function () {
                  scheduleRecommendationsRefresh(localSettings, { preserveExisting: true });
                });
              };

              if (publishResult && typeof publishResult.then === 'function') {
                publishResult.then(runRefresh).catch(function () { setTimeout(runRefresh, 200); });
              } else {
                // fallback
                setTimeout(runRefresh, 180);
              }
            } catch (e) {
              console.warn('[FreeShipping] publish cartUpdate failed', e);
              scheduleRecommendationsRefresh(undefined, { preserveExisting: true });
            }
          })
          .catch(function (error) {
            console.error('[FreeShipping] add to cart failed', error);
          })
          .finally(function () {
            setButtonState(button, false);
          });
      }, true);
    });
  }

  function buildProductCard(product, settings) {
    var productTitle = String(product.title || '').replace(/[<>"]/g, function (char) {
      return char === '<' ? '&lt;' : char === '>' ? '&gt;' : '&quot;';
    });
    var productUrl = String(product.url || '').replace(/"/g, '&quot;');
    var imageUrl = String(product.imageUrl || '').replace(/"/g, '&quot;');
    var priceText = String(product.priceText || '').replace(/[<>]/g, function (char) {
      return char === '<' ? '&lt;' : '&gt;';
    });
    var wrapperStyle = 'max-width:' + (settings.ui.cardMaxWidth || DEFAULT_SETTINGS.ui.cardMaxWidth) + 'px; padding:' + (settings.ui.cardPadding || DEFAULT_SETTINGS.ui.cardPadding) + 'px; box-sizing:border-box;';
    var imgStyle = 'padding:' + (settings.ui.imagePadding || DEFAULT_SETTINGS.ui.imagePadding) + 'px; width:100%; height:auto; display:block;';
    var buttonStyle = settings.ui.addToCartButtonColor ? 'background-color:' + settings.ui.addToCartButtonColor + ';border-color:black;' : '';

    return [
      '<div class="product-card-mini" data-product-id="' + product.id + '" style="' + wrapperStyle + '">',
      '  <a href="' + productUrl + '" class="product-card-mini__image">',
      imageUrl ? '    <img src="' + imageUrl + '" loading="lazy" alt="' + productTitle + '" style="' + imgStyle + '">' : '',
      '  </a>',
      '  <div class="product-card-mini__content">',
      '    <a href="' + productUrl + '" class="product-card-mini__title">' + productTitle + '</a>',
      (settings.ui.showDiscountedPrice || settings.ui.showOriginalPrice ? '    <div class="product-card-mini__price"><span class="jsPrice">' + priceText + '</span></div>' : ''),
      settings.ui.showAddToCart ? [
        '    <div class="product-card-mini__actions">',
        '      <product-form data-section-id="' + settings.sectionId + '">',
        '        <form class="form free-shipping-recommendation-form" action="/cart/add" method="post" novalidate="novalidate" data-type="add-to-cart-form">',
        '          <input type="hidden" name="id" value="' + (product.variantId || '') + '" class="product-variant-id">',
        '          <button type="submit" name="add" data-buy-button="' + product.id + '" data-original-text="Add to Cart" data-product-card-swatch-id="' + product.id + '" class="button button--addToCart button--primary button--filled button--primary__filled" aria-live="polite" style="' + buttonStyle + '">',
        '            <span data-button-text>' + settings.strings.addToCart + '</span>',
        '            <span class="sold-out-message hidden">' + settings.strings.soldOut + '</span>',
        '            <div class="loading__spinner hidden" aria-hidden="true"></div>',
        '          </button>',
        '        </form>',
        '      </product-form>',
        '    </div>'
      ].join('') : '',
      '  </div>',
      '</div>'
    ].join('');
  }

  function applyLayoutSettings(settings) {
    var target = document.querySelector(settings.selectors.recommendationsTarget);
    if (!target) return;

    var cardsPerRow = window.innerWidth < 768 ? settings.ui.cardsPerRowMobile || DEFAULT_SETTINGS.ui.cardsPerRowMobile : settings.ui.cardsPerRowDesktop || DEFAULT_SETTINGS.ui.cardsPerRowDesktop;
    target.style.display = 'grid';
    target.style.gridTemplateColumns = 'repeat(' + Math.max(1, cardsPerRow) + ', minmax(0, 1fr))';
    target.style.gap = (settings.ui.gap || DEFAULT_SETTINGS.ui.gap) + 'px';
  }

  function setRecommendationsVisibility(settings, isVisible) {
    var displayValue = isVisible ? 'block' : 'none';

    document.querySelectorAll(settings.selectors.upsellContainer).forEach(function (container) {
      container.style.display = displayValue;
    });

    document.querySelectorAll(settings.selectors.recommendationBox).forEach(function (box) {
      box.style.display = displayValue;
    });

    document.querySelectorAll(settings.selectors.heading).forEach(function (headingElement) {
      headingElement.style.display = displayValue;
    });
  }

  function renderRecommendations(products, settings, retryCount) {
    retryCount = retryCount || 0;

    var cartTotal = getCartTotal(settings);
    console.log('[FreeShipping] renderRecommendations products:', products.length, 'cartTotal:', cartTotal);
    if (isNaN(cartTotal)) {
      hideRecommendations(settings);
      return;
    }

    var nearestThreshold = getNearestThreshold(cartTotal, settings);
    if (nearestThreshold === undefined) {
      hideRecommendations(settings);
      return;
    }

    var target = document.querySelector(settings.selectors.recommendationsTarget);
    var headerActions = document.querySelector(settings.selectors.headerActions);
    var isCartDrawer = target && target.closest('cart-drawer, #CartDrawer');
    var initialLimit = window.innerWidth >= 768 ? settings.desktopInitialLimit : settings.initialLimit;
    var allProducts = products.slice(0, initialLimit + settings.viewAllLimit);
    var visibleProducts = allProducts.slice(0, initialLimit);
    var viewMoreHtml = '';
    console.log(target ? '[FreeShipping] renderRecommendations - target found' : '[FreeShipping] renderRecommendations - target not found');
    console.log(products.length ? '[FreeShipping] renderRecommendations - products available' : '[FreeShipping] renderRecommendations - no products available');
    if (!products.length) {
      console.log('[FreeShipping] renderRecommendations - no products, aborting');
      hideRecommendations(settings);
      return;
    }

    if (!target) {
      if (retryCount < 10) {
        console.log('[FreeShipping] renderRecommendations - target missing, retrying render');
        setTimeout(function () {
          renderRecommendations(products, settings, retryCount + 1);
        }, 100);
        return;
      }

      console.log('[FreeShipping] renderRecommendations - target still missing after retries, aborting');
      hideRecommendations(settings);
      return;
    }

    var productCardsHtml = visibleProducts.map(function (product) {
      return buildProductCard(product, settings);
    }).join('');

    if (!productCardsHtml) {
      hideRecommendations(settings);
      return;
    }

    if (target.parentElement) {
      target.parentElement.querySelectorAll('.free-shipping-view-more').forEach(function (element) {
        element.remove();
      });
    }

    if (allProducts.length > initialLimit) {
      viewMoreHtml = '<div class="free-shipping-view-more"><button type="button" class="free-shipping-view-more-btn">' + settings.strings.viewAll + '</button></div>';
    }

    if (headerActions) headerActions.innerHTML = '';

    target.innerHTML = productCardsHtml;

    if (viewMoreHtml) {
      if (isCartDrawer) {
        target.insertAdjacentHTML('afterend', viewMoreHtml);
      } else if (headerActions) {
        headerActions.innerHTML = viewMoreHtml;
      }
    }

    bindRecommendationAddToCartForms();
    applyLayoutSettings(settings);
    setRecommendationsVisibility(settings, true);
    console.log('[FreeShipping] renderRecommendations - completed rendering');
  }

  function bindViewMore(settings, state) {
    if (document.__freeShippingViewMoreBound) return;
    document.__freeShippingViewMoreBound = true;
    console.log('[FreeShipping] bindViewMore - listener bound');

    document.addEventListener('click', function (event) {
      var button = event.target.closest('.free-shipping-view-more-btn');
      if (!button) return;
      console.log('[FreeShipping] bindViewMore - view more clicked');

      var target = document.querySelector(settings.selectors.recommendationsTarget);
      var initialLimit = window.innerWidth >= 768 ? settings.desktopInitialLimit : settings.initialLimit;
      var nextProducts = state.allProducts.slice(initialLimit);

      if (target) {
        target.insertAdjacentHTML('beforeend', nextProducts.map(function (product) {
          return buildProductCard(product, settings);
        }).join(''));
        bindRecommendationAddToCartForms();
      }

      button.closest('.free-shipping-view-more').remove();
    });
  }

  function scheduleRecommendationsRefresh(customSettings, options) {
    [50, 200, 500, 1000].forEach(function (delay) {
      setTimeout(function () {
        fetchProductRecommendations(customSettings, options);
      }, delay);
    });
  }

  function fetchProductRecommendations(customSettings, options) {
    var settings = getSettings(customSettings);
    var preserveExisting = !!(options && options.preserveExisting);
    console.log('[FreeShipping] fetchProductRecommendations - start', { enabled: settings.enabled, preserveExisting: preserveExisting });
    if (!settings.enabled) {
      console.log('[FreeShipping] fetchProductRecommendations - disabled in settings, aborting');
      return;
    }

    document.querySelectorAll(settings.selectors.heading).forEach(function (headingElement) {
      headingElement.textContent = settings.heading || DEFAULT_SETTINGS.heading;
      if (settings.ui && settings.ui.headingSize) {
        headingElement.style.fontSize = settings.ui.headingSize + 'px';
      }
    });

    var cartTotal = getCartTotal(settings);
    if (isNaN(cartTotal)) {
      console.log('[FreeShipping] fetchProductRecommendations - invalid cart total, aborting');
      hideRecommendations(settings);
      return;
    }

    var nearestThreshold = getNearestThreshold(cartTotal, settings);
    if (nearestThreshold === undefined) {
      console.log('[FreeShipping] fetchProductRecommendations - no shipping threshold found, hiding recommendations');
      hideRecommendations(settings);
      return;
    }

    var remaining = nearestThreshold - cartTotal;
    console.log('[FreeShipping] fetchProductRecommendations - remaining to threshold:', remaining);
    if (remaining <= 0) {
      console.log('[FreeShipping] fetchProductRecommendations - already qualified for free shipping, hiding recommendations');
      hideRecommendations(settings);
      return;
    }

    var categoryFilters = getMatchedCategoryFilters(settings);
    if (!categoryFilters) {
      console.log('[FreeShipping] fetchProductRecommendations - no category filters matched, hiding recommendations');
      hideRecommendations(settings);
      return;
    }

    var initialLimit = window.innerWidth >= 768 ? settings.desktopInitialLimit : settings.initialLimit;

    fetchProductsForThreshold(categoryFilters, nearestThreshold, settings, cartTotal)
      .then(function (products) {
        console.log('[FreeShipping] fetchProductRecommendations - fetched products count:', products.length);
        var state = { allProducts: products.slice(0, initialLimit + settings.viewAllLimit) };
        if (!state.allProducts.length) {
          hideRecommendations(settings);
          return;
        }
        renderRecommendations(state.allProducts, settings);
        bindViewMore(settings, state);
        console.log('[FreeShipping] fetchProductRecommendations - render and bind complete');
      })
      .catch(function (error) {
        console.error(settings.strings.collectionFetchError + ':', error);
        hideRecommendations(settings);
      });
  }

  function initFreeShippingRecommendations() {
    console.log('[FreeShipping] initFreeShippingRecommendations - init called');
    fetchProductRecommendations();
    console.log('[FreeShipping] initFreeShippingRecommendations - fetch triggered');
  }

  function hideRecommendations(settings) {
    try {
      settings = settings || (window.freeShippingSettings ? getSettings(window.freeShippingSettings) : getSettings());
      document.querySelectorAll(settings.selectors.recommendationsTarget).forEach(function (target) {
        target.innerHTML = '';
        target.style.display = '';
      });
      document.querySelectorAll(settings.selectors.headerActions).forEach(function (headerActions) {
        headerActions.innerHTML = '';
      });
      document.querySelectorAll('.free-shipping-view-more').forEach(function (viewMore) {
        viewMore.remove();
      });
      setRecommendationsVisibility(settings, false);
    } catch (e) {
      console.warn('[FreeShipping] hideRecommendations failed', e);
    }
  }

  function refreshCartSections(settings) {
    try {
      settings = settings || (window.freeShippingSettings ? getSettings(window.freeShippingSettings) : getSettings());

      var cartEl = document.querySelector('cart-items') || document.querySelector('cart-drawer-items') || document.querySelector('cart-notification');
      var sections = [];

      if (cartEl && typeof cartEl.getSectionsToRender === 'function') {
        sections = cartEl.getSectionsToRender();
      } else {
        // Fallback: collect common cart/footer sections present on the page
        ['main-cart-items', 'main-cart-footer', 'detailed-cart-footer', 'cart-drawer'].forEach(function (id) {
          var el = document.getElementById(id);
          if (el && el.dataset && el.dataset.id) {
            sections.push({ id: id, section: el.dataset.id, selector: el.querySelector('.js-contents') ? '.js-contents' : '' });
          }
        });
      }

      if (!sections.length) return Promise.resolve();

      return Promise.all(sections.map(function (s) {
        if (!s || !s.section) return Promise.resolve();
        return fetch(routes.cart_url + '?section_id=' + encodeURIComponent(s.section), { cache: 'no-store' })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            try {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var source = doc.getElementById(s.section) || doc.getElementById('shopify-section-' + s.section) || doc.getElementById(s.id) || doc.querySelector('[data-section-id="' + s.section + '"]') || doc.body;
              var target = document.getElementById(s.id);
              if (!target) return;
              if (s.selector) {
                var srcInner = source.querySelector(s.selector) || source.querySelector('.js-contents') || source;
                var tgtInner = target.querySelector(s.selector) || target.querySelector('.js-contents') || target;
                if (srcInner && tgtInner) tgtInner.innerHTML = srcInner.innerHTML;
                else target.innerHTML = source.innerHTML;
              } else {
                target.innerHTML = source.innerHTML || doc.body.innerHTML;
              }
            } catch (e) {
              console.warn('[FreeShipping] refreshCartSections replace error', e);
            }
          }).catch(function (e) {
            console.warn('[FreeShipping] refreshCartSections fetch error', e);
          });
      }));
    } catch (e) {
      console.warn('[FreeShipping] refreshCartSections failed', e);
      return Promise.resolve();
    }
  }

  // Subscribe to native cart updates so we can re-evaluate recommendations
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    try {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        console.log('[FreeShipping] received cartUpdate event, re-evaluating recommendations', event && event.source);
        scheduleRecommendationsRefresh(undefined, { preserveExisting: true });
      });
    } catch (e) {
      console.warn('[FreeShipping] subscribe to cartUpdate failed', e);
    }
  }

  window.FreeShippingRecommendations = {
    init: initFreeShippingRecommendations,
    fetch: fetchProductRecommendations,
    getSettings: getSettings,
    getShippingThresholds: function (customSettings) {
      return getShippingThresholds(getSettings(customSettings));
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFreeShippingRecommendations);
  } else {
    initFreeShippingRecommendations();
  }
})(window, document);
